import { useLocation } from 'react-router-dom';

export { useExperiments } from './Experiments';

export const useQueryParams = () => {
  const { search } = useLocation();
  return new URLSearchParams(search);
};
